import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRoute } from '@hvsin/mod-route';
import { useCategories } from '../hooks/use-categories.js';
/**
 * 分类列表页
 */
export function CategoryListPage() {
    const { Link, useNavigate } = useRoute();
    const navigate = useNavigate();
    const { categories, loading, error } = useCategories();
    if (loading) {
        return (_jsx("div", { style: styles.page, children: _jsx("div", { style: styles.loading, children: "\u52A0\u8F7D\u4E2D..." }) }));
    }
    if (error) {
        return (_jsx("div", { style: styles.page, children: _jsx("div", { style: styles.error, children: error }) }));
    }
    return (_jsxs("div", { style: styles.page, children: [_jsx("header", { style: styles.header, children: _jsxs("div", { style: styles.headerContent, children: [_jsx("h1", { style: styles.title, children: "\u5206\u7C7B" }), _jsx("p", { style: styles.subtitle, children: "\u6309\u5206\u7C7B\u6D4F\u89C8\u6587\u7AE0" })] }) }), _jsxs("main", { style: styles.main, children: [categories.length === 0 ? (_jsx("div", { style: styles.empty, children: _jsx("p", { style: styles.emptyText, children: "\u6682\u65E0\u5206\u7C7B" }) })) : (_jsx("div", { style: styles.grid, children: categories.map(cat => (_jsx(Link, { to: `/post?categorySlug=${encodeURIComponent(cat.slug)}`, style: styles.card, children: _jsxs("div", { style: styles.cardContent, children: [_jsxs("div", { style: styles.cardTop, children: [_jsx("h2", { style: styles.cardTitle, children: cat.name }), _jsxs("span", { style: {
                                                    ...styles.countBadge,
                                                    backgroundColor: cat.color || '#f0fdf4',
                                                    color: cat.color ? '#ffffff' : '#166534',
                                                }, children: [cat.postCount, " \u7BC7"] })] }), cat.description && (_jsx("p", { style: styles.cardDescription, children: cat.description }))] }) }, cat.slug))) })), _jsx("div", { style: styles.backLink, children: _jsx(Link, { to: "/post", style: styles.backButton, onClick: (e) => {
                                e.preventDefault();
                                navigate('/post');
                            }, children: "\u2190 \u8FD4\u56DE\u5168\u90E8\u6587\u7AE0" }) })] })] }));
}
const styles = {
    page: {
        minHeight: '100vh',
        backgroundColor: '#fafafa',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        color: '#1a1a1a',
    },
    header: {
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #eaeaea',
        padding: '60px 24px 40px',
        textAlign: 'center',
    },
    headerContent: {
        maxWidth: '720px',
        margin: '0 auto',
    },
    title: {
        margin: '0 0 8px 0',
        fontSize: '32px',
        fontWeight: 700,
        color: '#1a1a1a',
        letterSpacing: '-0.02em',
    },
    subtitle: {
        margin: 0,
        fontSize: '16px',
        color: '#666666',
    },
    main: {
        maxWidth: '720px',
        margin: '0 auto',
        padding: '40px 24px 60px',
    },
    loading: {
        padding: '80px 0',
        textAlign: 'center',
        color: '#999',
        fontSize: '15px',
    },
    error: {
        padding: '16px',
        backgroundColor: '#fff5f5',
        border: '1px solid #fed7d7',
        borderRadius: '8px',
        color: '#c53030',
        fontSize: '14px',
        marginTop: '20px',
    },
    empty: {
        padding: '80px 0',
        textAlign: 'center',
    },
    emptyText: {
        fontSize: '16px',
        color: '#999',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '16px',
    },
    card: {
        display: 'block',
        padding: '20px',
        backgroundColor: '#ffffff',
        borderRadius: '10px',
        border: '1px solid #eaeaea',
        textDecoration: 'none',
        color: 'inherit',
        transition: 'all 0.15s ease',
        cursor: 'pointer',
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    cardTop: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
    },
    cardTitle: {
        margin: 0,
        fontSize: '18px',
        fontWeight: 600,
        color: '#1a1a1a',
    },
    countBadge: {
        padding: '4px 10px',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        flexShrink: 0,
    },
    cardDescription: {
        margin: 0,
        fontSize: '14px',
        color: '#666666',
        lineHeight: '1.5',
    },
    backLink: {
        marginTop: '40px',
        textAlign: 'center',
    },
    backButton: {
        fontSize: '14px',
        color: '#6366f1',
        textDecoration: 'none',
        fontWeight: 500,
    },
};
//# sourceMappingURL=category-list-page.js.map